import App from '@/App';
/* @refresh reload */
import { render } from 'solid-js/web';
import '@/env';
import '@/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

render(() => <App />, root);
